import { Outlet, createFileRoute } from "@tanstack/react-router";

import AcademyHeader from "@/components/marketing/AcademyHeader";
import MarketingFooter from "@/components/marketing/MarketingFooter";
import MarketingShell from "@/components/marketing/MarketingShell";
import { useNotFoundBelow } from "@/components/marketing/useNotFoundBelow";

/**
 * A sibling of `_app` and of `blog`, for the same reason both are: the academy
 * is public, and `_app` mounts the authenticated provider tree whose
 * `RouteGuard` would bounce anonymous readers to the login page.
 *
 * No clearance box, unlike the blog's, the published academy bar is in flow.
 * The footer IS the blog's: measured at 1280 the two pages render the same
 * `div.bottom_footer-wrapper`, 1280x465, with the same thirty-two links.
 */
export const Route = createFileRoute("/academy-article")({
  component: AcademyLayout,
});

function AcademyLayout() {
  if (useNotFoundBelow()) {
    return (
      <MarketingShell>
        <Outlet />
      </MarketingShell>
    );
  }
  return (
    <MarketingShell>
      <AcademyHeader />
      <Outlet />
      <MarketingFooter />
    </MarketingShell>
  );
}
